function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M12.984 16.286l8.328-.497.553-3.917h-9.766z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M16 0C7.163 0 0 7.163 0 16s7.163 16 16 16 16-7.163 16-16S24.837 0 16 0zm-1.913 23.049a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm6.428 0a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm2.104-6.498a.702.702 0 0 1-.651.602l-8.705.521.182.908h8.166a.7.7 0 1 1 0 1.4h-8.729a.7.7 0 0 1-.684-.551l-.494-2.258-.003-.014-.001-.002-1.14-5.852-.481-1.619-.873-.156a.698.698 0 1 1 .247-1.377l1.297.233a.7.7 0 0 1 .548.49l.472 1.596h10.901a.697.697 0 0 1 .693.798l-.745 5.281z"
});

var SvgCartEmptyFilled = function SvgCartEmptyFilled(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 16 : _ref$size,
      props = _objectWithoutProperties(_ref, ["size"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    height: size,
    width: size
  }, props), _ref2, _ref3);
};

export default SvgCartEmptyFilled;